/* eslint-disable @typescript-eslint/no-var-requires */
import { Button, Modal } from 'antd';
import React, {
  FunctionComponent,
  MutableRefObject,
  useEffect,
  useRef,
  useState,
} from 'react';
import './animation009.less';
import ImgPoint from '../../../../../assets/animation_point.gif';
import { usePlayFlag } from './../../components/topicScroll';

interface IAnimation009SubItem {
  img: string;
  title: string;
}

interface IAnimation009Item {
  icon: string;
  color: string;
  text: string;
  tip?: string;
  subItems?: IAnimation009SubItem[];
}

interface IAnimation009Props {
  items: IAnimation009Item[];
  tip: string;
  onCompleted: () => void;
}

const Animation009: FunctionComponent<IAnimation009Props> = ({
  items,
  tip,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 2) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation009 onCompleted');
      onCompleted && onCompleted();
    }
  };
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;

  useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };

  const [isModalOpen, setModalOpen] = useState(false);
  const [modalItem, setModalItem] = useState<IAnimation009SubItem[]>();
  const [show, setShow] = useState<number[]>([]);

  return (
    <div ref={crrRef} className="animation009 component" style={{ margin: 0 }}>
      {/* <div
        className="animation009-tip"
        dangerouslySetInnerHTML={{ __html: tip }}
      /> */}
      <div className="animation009-content">
        {items.map((itm: IAnimation009Item, idx: number) => (
          <div
            onClick={() => clickToPlay()}
            key={idx}
            className={`animation009-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            style={{
              width: `${(1 / items.length) * 100 * 2}%`,
              color: itm.color,
            }}
          >
            <img
              className="click-point"
              onClick={() => clickToPlay()}
              style={{
                display: play <= 1 ? 'block' : 'none',
              }}
              src={ImgPoint}
              alt=""
            />
            <div className="animation009-indicate">
              <div
                className="animation009-icon"
                style={{ backgroundColor: itm.color }}
              >
                <img src={getImg(itm.icon)} alt="" />
              </div>
              <div className="animation009-indicate-number">0{idx + 1}</div>
            </div>
            <div
              className="animation009-text"
              dangerouslySetInnerHTML={{ __html: itm.text }}
            />
            {itm.subItems ? (
              <div>
                <Button
                  className="view-more-btn"
                  onClick={() => {
                    setModalItem(itm.subItems);
                    setModalOpen(true);
                    setShow([...show, idx]);
                  }}
                  type="link"
                >
                  <div className="tip-btn" style={{ color: itm.color }}>
                    {itm.tip}
                  </div>
                  <img
                    className="click-point1"
                    hidden={show.includes(idx)}
                    src={ImgPoint}
                    alt=""
                  />
                </Button>
              </div>
            ) : null}
          </div>
        ))}
      </div>
      {modalItem && (
        <Modal
          width="60%"
          className="animation009-modal"
          title={
            <div className="animation009-modal-header">
              <div className="animation009-modal-title">
                {modalItem[0]?.title}
              </div>
            </div>
          }
          footer={null}
          visible={isModalOpen}
          onCancel={() => setModalOpen(false)}
        >
          <img
            src={require(`../../../../../assets/${modalItem[0]?.img}`).default}
            alt=""
          />
        </Modal>
      )}
    </div>
  );
};

export default Animation009;
